export enum ClientErrorTypes {
  BadRequest = 'BadRequest',
  Unauthorized = 'Unauthorized',
  Forbidden = 'Forbidden',
  UnprocessableEntity = 'UnprocessableEntity',
  Conflict = 'Conflict',
  InternalServer = 'InternalServer',
}

export const CLIENT_API_ERRORS = {
  400: ClientErrorTypes.BadRequest,
  401: ClientErrorTypes.Unauthorized,
  403: ClientErrorTypes.Forbidden,
  422: ClientErrorTypes.UnprocessableEntity,
  409: ClientErrorTypes.Conflict,
  500: ClientErrorTypes.InternalServer,
};
